module.exports = __webpack_public_path__ + "media/npc_dota_hero_night_stalker.5ef4b708.webm";